import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { useRouter } from "next/router";

export { useIsOwnerByQuery } from "@/hooks/useIsOwnerByQuery";

export const defaultValue = {
  user: {
    phone: null,
    name: null,
    user_id: null,
    img: null,
    email: null,
    about: null,
    chosen_user_type: null,
    iam_verified: null,
    listings: null,
    favs: null,
    type: null,
    active_aqar_plus_user: null,
    show_aqar_plus: null,
    paid: null,
    create_time: null,
  },
  token: null,
  web_intercom_hmac: null,
  userCards: [],
};

/* eslint-disable */

export const AuthContext = createContext(defaultValue);

export default function AuthContextProvider({ value, children } = {}) {
  const [state, setState] = useState(value || defaultValue);
  return (
    <AuthContext.Provider
      value={{
        ...state,
        updateContext: (value) => {
          setState({ ...state, ...value });
        },
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
export function isOwner({ listing, user }) {
  return (
    user &&
    listing &&
    (listing.user_id === user?.user_id ||
      listing.employee_user_id === user?.user_id ||
      listing.mgr_user_id === user?.user_id)
  );
}
export function useIsOwner(listing) {
  const { user } = useAuthState();
  return isOwner({ listing, user });
}
export function useAuthState(select) {
  if (!select) return useContext(AuthContext);
  return useContext(AuthContext)[select];
}
